import React from 'react'
import styled, { css } from 'styled-components'

import ActionButton, { ActionGroupItem } from './ActionButton'

export type ActionGroupType = Array<ActionGroupItem>

const BaseActionGroup = ({
  actions,
  className,
}: {
  actions: ActionGroupType
  className?: string
}) => {
  if (!actions) return null
  return (
    <div className={className}>
      {actions.map(({ children, ...action }) => (
        <ActionButton key={`button$${children}`} {...action}>
          {children}
        </ActionButton>
      ))}
    </div>
  )
}

const ActionGroup = styled(BaseActionGroup)`
  ${({ theme: { spacing, breakpoints } }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: ${spacing(0, 2)};
    width: 100%;
    ${breakpoints.up('md')} {
      align-items: flex-start;
      flex-flow: row wrap;
      justify-content: flex-start;
      padding: ${spacing(0, 0, 0, 2)};
      width: auto;
    }
  `}
`

export default ActionGroup
